var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRedesignEnabled === null)?_c('div',{staticClass:"eap-gate-loading"},[_c('b-spinner')],1):(_vm.isRedesignEnabled)?_c('Eap'):_c('EapLegacy')}
var staticRenderFns = []

export { render, staticRenderFns }